// validation.js

export const validateForm = ({ username, email, password }) => {
    const errors = {};
  
    // Username Validation
    if (!username || username.trim() === "") {
      errors.username = "Username is required";
    }
  
    // Email Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.email = "Valid email is required";
    }
  
    // Password Validation
    const passwordErrors = [];
  
    if (!password) {
      passwordErrors.push("Password is required");
    } else {
      if (password.length < 8) {
        passwordErrors.push("Password must be at least 8 characters");
      }
      if (!/[A-Z]/.test(password)) {
        passwordErrors.push("Password must contain at least one uppercase letter");
      }
      if (!/[a-z]/.test(password)) {
        passwordErrors.push("Password must contain at least one lowercase letter");
      }
      if (!/[0-9]/.test(password)) {
        passwordErrors.push("Password must contain at least one digit");
      }
      if (!/[@$!%*?&#]/.test(password)) {
        passwordErrors.push("Password must contain at least one special character (@$!%*?&#)");
      }
    }
  
    if (passwordErrors.length > 0) {
      errors.password = passwordErrors;
    }
  
    return errors;
  };
  